export const comprobantesProcess = (comprobantes: any) => {
  let sumatoriaDeImpuestos = 0.0;
  let sumComprobantesTotales = 0.0;
  let sumTotalSinPercepciones = 0.0;

  comprobantes.forEach((item:any) => {
    if (item.fat_descripcion_red === "NC" || item.fat_descripcion_red === "NC FAC") {
      sumatoriaDeImpuestos -= item.fac_impuestos;
      sumComprobantesTotales -= item.fac_total;
      sumTotalSinPercepciones -= (item.fac_total - (item.fac_IIBB_percepcion + item.fac_iva_percepcion));
    } else {
      sumatoriaDeImpuestos += item.fac_impuestos;
      sumComprobantesTotales += item.fac_total;
      sumTotalSinPercepciones += (item.fac_total - (item.fac_IIBB_percepcion + item.fac_iva_percepcion));
    }
  });

  return { sumatoriaDeImpuestos, sumComprobantesTotales, sumTotalSinPercepciones };
};
